import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./index.css";
import { Col, Modal, Row, Stack } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { onChangeToNumber } from "../../../../utils/helperFunction";
import { toast } from "react-toastify";
import { Html5QrcodeScanner, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { useDispatch, useSelector } from "react-redux";
import { setdetailReportFilledItem } from "../../../../redux/slice/DetailReportSummarySlice";
import API from "../../../../services/api";
import { usePic } from "../../../../context/PicProvider";
import ProductTableView from "../common/ProductTableView";
import BarScanIcon from "../../../../Assets/icons/bar-scan-icon.svg";
const DetailedReportFilledItem = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setIsLoadingText } = usePic();
  const { detailReportFilledItem, detailReportActionData } = useSelector(
    (state) => state.DetailReport
  );
  const { quichReportData, injuryType } = useSelector(
    (state) => state.QUICKREPORT
  );

  const [itemDropDownArr, setItemDropDownArr] = useState(quichReportData);

  // main state of form
  const [showScanner, setShowScanner] = useState(false);
  const [formData, setFormData] = useState(detailReportFilledItem);
  const [scannedCodes, setScannedCodes] = useState("");
  const [isItemFound, setIsItemFound] = useState(false);

  useEffect(() => {
    if (scannedCodes !== "") {
      getBarcodeDetail();
    }
  }, [scannedCodes]);

  useEffect(() => {
    if (injuryType === "single") {
      setFormData((prev) => ({
        ...prev,
        usedBy: {
          value: detailReportActionData?.personOfTreatment?.value ?? "",
          warning: false,
        },
      }));
    }
  }, []);

  // Handle state changes of inputs
  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "quantity") {
      const currentProduct = itemDropDownArr?.products?.find(
        (item) => item?._id === formData?.item?.value
      );
      if (currentProduct) {
        const numericValue = Number(value);
        if (numericValue <= currentProduct?.current_quantity) {
          setFormData((prev) => ({
            ...prev,
            [name]: { value: value, warning: !value ? true : false },
          }));
        } else {
          toast.error(
            `Quantity must be less then or equal to ${currentProduct?.current_quantity}`
          );
        }
      } else {
        toast.error(`Please Select product`);
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: { value: value, warning: !value ? true : false },
      }));
    }
  };

  // validate the form
  const validateForm = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      item: { ...data.item, warning: !data.item.value },
      quantity: { ...data.quantity, warning: !data.quantity.value },
      usedBy: {
        ...data.usedBy,
        warning: !data.usedBy.value,
      },
    };
    setFormData((prev) => ({
      ...prev,
      ...data,
    }));
    if (!data.quantity.warning && !data.usedBy.warning) {
      const { item, quantity, usedBy } = data;
      setFormData((prev) => ({
        ...prev,
        formDataArray: [
          ...(prev.formDataArray || []),
          { item, quantity, usedBy },
        ],
        // Reset form fields
        item: { value: "", warning: false },
        quantity: { value: "", warning: false },
      }));
      setIsItemFound(false);
    }
  };
  // after scan  we call api which give product list
  const getBarcodeDetail = async () => {
    const barCode = JSON.parse(scannedCodes);
    setIsLoadingText(true);
    try {
      const res = await API.get(
        `/admin/product?barcode=${barCode}&kit_id=${quichReportData?.kit_data?._id}`
      );
      const result = res.data;
      if (res.data?.status === 200) {
        if (result.is_product && result?.data?.product?.length > 0) {
          setIsItemFound(true);
          setFormData((prev) => ({
            ...prev,
            item: {
              ...prev.item,
              value: result?.data?.product[0]?._id,
            },
          }));
        } else {
          toast.error("Product not found");
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(
        "Failed to fetch product management data:",
        JSON.stringify(error)
      );
    } finally {
      setScannedCodes("");
      setIsLoadingText(false);
    }
  };

  // validate whole form
  const validateWholeFormValue = (event) => {
    event.preventDefault();
    if (
      !formData.item.warning &&
      !formData.quantity.warning &&
      !formData.usedBy.warning &&
      formData?.formDataArray?.length !== 0
    ) {
      dispatch(setdetailReportFilledItem(formData));
      navigate("/detailedincidentreportsummary");
    }
  };

  const handleOpenScanner = () => {
    setShowScanner(true);
  };

  const handleCloseScanner = () => {
    const stopButton = document.getElementById(
      "html5-qrcode-button-camera-stop"
    );
    if (stopButton) {
      stopButton.click();
    }
    setTimeout(() => {
      setShowScanner(false);
    }, 300);
  };

  useEffect(() => {
    if (showScanner) {
      // Initialize scanner only if it's not already initialized
      const html5QrcodeScanner = new Html5QrcodeScanner("qr-reader", {
        fps: 10,
        qrbox: 250,
        aspectRatio: 1.0,
        formatsToSupport: Object.values(Html5QrcodeSupportedFormats),
      });

      html5QrcodeScanner.render(
        (result) => {
          setScannedCodes(JSON.stringify(result)); // Set the scanned result
          handleCloseScanner(); // Close the modal after successful scan
        },
        (error) => {
          // toast.error(error); // Handle any errors during scanning
        }
      );
    }
  }, [showScanner]);

  const getProductName = (id) => {
    const currentItem = itemDropDownArr?.products?.find(
      (item) => item?._id === id
    );
    return currentItem?.description ?? "";
  };

  const groupedData = formData?.formDataArray?.reduce((acc, item) => {
    const personName = item?.usedBy?.value;
    if (!acc[personName]) {
      acc[personName] = [];
    }
    acc[personName]?.push(item);
    return acc;
  }, {});

  const result = Object.keys(groupedData)?.map((key) => ({
    name: key,
    array: groupedData[key],
  }));

  const handleQuantityChange = (e, index) => {
    let data = [...(formData?.formDataArray ?? [])];
    let newQuantity = Number(e.target.value);
    if (newQuantity < 1) {
      toast.error("Minimum quantity is 1");
      return;
    }

    const currentProduct = quichReportData?.products?.find(
      (item) => item._id === data[index]?.item?.value
    );
    if (currentProduct && newQuantity > currentProduct?.current_quantity) {
      toast.error(`Maximum quantity is ${currentProduct?.current_quantity}`);
      return;
    }

    data[index] = {
      ...data[index],
      quantity: {
        ...data[index].quantity,
        value: newQuantity,
      },
    };

    setFormData((prev) => ({
      ...prev,
      formDataArray: data,
    }));
  };

  const getTableBody = (data) => {
    const tableBody =
      data?.length > 0
        ? data?.map((item, index) => {
            return {
              cell: [
                {
                  data: (
                    <div>
                      <h6>{getProductName(item?.item?.value)}</h6>
                    </div>
                  ),
                  align: "start",
                },
                {
                  data: (
                    <Stack
                      direction="horizontal"
                      className="justify-content-center"
                    >
                      <Form.Control
                        type="number"
                        value={item?.quantity?.value}
                        min="1"
                        placeholder="Qty"
                        onChange={(e) => {
                          handleQuantityChange(e, index);
                        }}
                        size="sm"
                        style={{ width: "70px", height: "40px" }}
                        className="text-center"
                      />
                    </Stack>
                  ),
                  align: "center",
                },
              ],
            };
          })
        : [];
    return tableBody;
  };

  return (
    <>
      <Modal
        show={showScanner}
        onHide={handleCloseScanner}
        centered
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>QR Code Scanner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            id="qr-reader"
            style={{ height: "400px" }}
            className="w-100"
          ></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseScanner}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Form className="flex-grow-1 d-flex flex-column justify-content-between">
        <div className="incident-report-container">
          <h6 className="mb-3 fw-bold text-center">What items were used?</h6>
          <Button
            variant="primary"
            size="lg"
            className="button_custom text-black fw-bold d-flex align-items-center w-100"
            onClick={handleOpenScanner}
            style={{ padding: 0, fontSize: 18 }}
            // style={{ fontSize: 18, borderRadius: "0px 8px 8px 0px" }}
          >
            <img
              src={BarScanIcon}
              alt="bar-add-icon"
              style={{ borderRadius: "8px 0px 0px 8px" }}
            />
            <div className="flex-fill">Scan Barcode</div>
          </Button>
          {isItemFound && (
            <Stack className="align-items-center">
              <span className="text-success mt-2 mb-0">
                Success, item found
              </span>
            </Stack>
          )}
          <hr className="my-4" />
          <Stack className="row-gap-3">
            <Form.Group>
              {injuryType === "single" ? (
                <Form.Control
                  type="text"
                  disabled={formData.usedBy.value ? true : false}
                  placeholder="Person of treatment"
                  name={"usedBy"}
                  value={formData.usedBy.value}
                />
              ) : (
                <Form.Select
                  aria-label="Default select example"
                  className="customselectbox"
                  value={formData.usedBy.value}
                  name={"usedBy"}
                  onChange={onChange}
                  placeholder="Person of treatment"
                >
                  <option disabled value="" className="option-title">
                    Person of treatment
                  </option>
                  {detailReportActionData.formArr.length > 0 &&
                    detailReportActionData.formArr?.map((item, index) => (
                      <option
                        value={item?.personOfTreatment?.value}
                        key={index}
                      >
                        {item?.personOfTreatment?.value}
                      </option>
                    ))}
                </Form.Select>
              )}
              {formData.usedBy.warning && (
                <p className="text-danger mt-1 mb-0">
                  Select person of treatment
                </p>
              )}
            </Form.Group>
            <Form.Group controlId="formBasicEmail">
              <Form.Select
                aria-label="Default select example"
                className="custom-select-box"
                value={formData.item.value}
                name={"item"}
                onChange={onChange}
              >
                <option disabled value="" className="option-title">
                  Item
                </option>
                {itemDropDownArr &&
                  itemDropDownArr?.products?.map((item, index) => (
                    <option value={item?._id} key={index}>
                      {item?.description}
                    </option>
                  ))}
              </Form.Select>
              {formData.item.warning && (
                <p className="text-danger mt-1 mb-0">Select item</p>
              )}
            </Form.Group>
            <div>
              <Row className="row-gap-3 gx-3">
                <Col xs={4} md={3} xxl={2.5}>
                  <Form.Group controlId="formBasicItem">
                    <Form.Label className="d-none"></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Qty"
                      onChange={onChange}
                      name={"quantity"}
                      value={onChangeToNumber(formData.quantity.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={8} md={9} xxl={9.5}>
                  <Button
                    variant="dark"
                    className="w-100 h-100 fw-bold letter_spacing"
                    onClick={validateForm}
                  >
                    Assign Used Item
                  </Button>
                </Col>
              </Row>
              {formData.quantity.warning && (
                <p className="text-danger mt-1 mb-0">Enter qty</p>
              )}
            </div>
            {formData?.formDataArray?.length > 0 && (
              <>
                {result.map((item, index) => {
                  return (
                    <ProductTableView
                      key={index}
                      tableHeader={[
                        { name: `Used by ${item.name}`, align: "left" },
                        { name: "Quantity", align: "center" },
                      ]}
                      tableBody={getTableBody(item.array)}
                    />
                  );
                })}
              </>
            )}
          </Stack>
          {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      className="custom-select-box"
                      value={formData.usedBy.value}
                      name={"usedBy"}
                      onChange={onChange}
                      placeholder="Used by"
                    />

                    {formData.usedBy.warning && (
                      <span className="text-danger mt-1 mb-0">
                        Select used by
                      </span>
                    )}
                  </Form.Group> */}
        </div>
        <div className="incident-report-form-footer-action">
          <NavLink to="/detailedreportaction" className={"nav-link"}>
            <Button variant="dark fw-bold h-100">Cancel</Button>
          </NavLink>
          <div>
            <Button
              variant="primary"
              className="button_custom text-black fw-bold"
              onClick={(e) => validateWholeFormValue(e)}
              disabled={formData?.formDataArray?.length === 0 ? true : false}
            >
              Continue
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default DetailedReportFilledItem;
